export default __webpack_public_path__ + "static/media/Songwriter_Bible_img.264538f6.png";